import { render, staticRenderFns } from "./ItemBlock.vue?vue&type=template&id=6d000e5a&scoped=true&"
import script from "./ItemBlock.vue?vue&type=script&lang=js&"
export * from "./ItemBlock.vue?vue&type=script&lang=js&"
import style0 from "./ItemBlock.vue?vue&type=style&index=0&id=6d000e5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d000e5a",
  null
  
)

export default component.exports